
import { mixins, Options } from "vue-class-component";
import OutGoingMixins from "@/app/ui/views/out-going-shipment/out-going-mixin";
import CargoTypeSection from "@/app/ui/views/cargo/booking-cargo/third-step/cargo-type-section.vue";
import CargoDetailDeliverySection from "@/app/ui/views/cargo/booking-cargo/third-step/cargo-detail-delivery-section.vue";
import CargoTableSttSection from "@/app/ui/views/cargo/booking-cargo/third-step/cargo-table-stt-section.vue";
import CargoFlightManualSection from "@/app/ui/views/cargo/booking-cargo/third-step/cargo-flight-manual-section.vue";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import { gtmCargoData } from "@/app/ui/views/cargo/modules/gtm";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import WeightSummaryStt from "../first-step/weight-summary-stt.vue";
import WeightSummaryTimbangUlang from "../first-step/weight-summary-timbang-ulang.vue";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { UploadMultiple } from "@/domain/entities/MainApp";
import { BookingController } from "@/app/ui/controllers/BookingController";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { parsingErrorResponse, parseByCountry } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import SectionUploadPhotoForWeightAdjusment from "../../component/section-upload-photo-for-weight-adjustment/index.vue";

@Options({
  components: {
    CargoFlightManualSection,
    CargoTableSttSection,
    CargoDetailDeliverySection,
    CargoTypeSection,
    WeightSummaryStt,
    WeightSummaryTimbangUlang,
    SectionUploadPhotoForWeightAdjusment,
  }
})
export default class ThirdStep extends mixins(OutGoingMixins) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  loadingFirstLanding = false;
  openAdjustmentWeight = true;

  created() {
    if (this.formBooking.cargoType === "plane") {
      // GTM
      if (!this.isCargoPlaneManual) {
        const gtmDetailView = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: !this.isCargoPlaneManual
        }).detailView;
        dataLayer(gtmDetailView.eventName, gtmDetailView.property, []);
      } else {
        const gtmDetailViewAwb = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: !this.isCargoPlaneManual
        }).detailViewAwb;
        dataLayer(gtmDetailViewAwb.eventName, gtmDetailViewAwb.property, []);
      }
    }
  }
  mounted() {
    if (this.flowBooking == "rtc-process") {
      this.formBooking.cargoType = ReadyToCargoController.readyToCargoDetail.cargoType;
    } else {
      this.formBooking.cargoType = CargoController.cargoType?.type;
      this.formBooking.cargoTypeStatus = CargoController.cargoType?.status;
    }

    if (CargoController.isFillForm) {
      CargoController.setFillForm(CargoController.isFillForm);
      return;
    }
    CargoController.setFillForm(!this.isCargoPlaneManual);
  }

  mappingReadyToCargo() {
    CargoController.mappingReadyToCargo();
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }

  get isDimensionChanged() {
    return CargoController.isDimensionChanged;
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(this.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  get isRebooking() {
    return this.flowBooking === "rebooking";
  }

get isErrorWeightAdjustment() {
    const isError = CargoController.calculateVolumeData.isUploadProofPhoto;
    const showValidation =
      isError &&
      this.isValidationAdjustWeightProofPhotoEnable &&
      !this.loadingFirstLanding;
    if (!showValidation && !this.isRebooking) this.formBooking.photoProof = [];
    return showValidation;
  }

  get cargoInputForm() {
    return CargoController.cargoInputForm;
  }

  get isValidationAdjustWeightProofPhotoEnable() {
    return (
      FlagsPermissionCargo.validation_adjust_weight_proof_photo_enable.isEnabled() &&
      (this.flowBooking !== "rebooking" || this.cargoInputForm.isAllowUseProof)
    );
  }

  get flowBooking() {
    return ReadyToCargoController.flowBooking;
  }

  get isFillForm() {
    return CargoController.isFillForm;
  }
  get formBooking() {
    return CargoController.form;
  }
  get isCargoPlaneManual() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus !== "auto"
    );
  }

  get totalPcs() {
    return CargoController.totalPcs;
  }

  get totalGrossWeights() {
    return CargoController.totalGrossWeights || "0";
  }

  get totalVolumeWeights() {
    return CargoController.totalVolumeWeights;
  }

  get sttCalculation() {
    return {
      grossWeight: Number(this.totalGrossWeights),
      volumeWeight: this.totalVolumeWeights
    };
  }

  get actualChargeableWeight() {
    if (CargoController.isAwbValid) return Math.max(
      1,
      this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
      this.parseNumber(this.formBooking.totalCargoVolumeWeight as any),
    )
    return CargoController.calculateVolumeData.chargeableWeight;
  }

  async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.formBooking.photoProof[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.formBooking.photoProof[index]]
        })
      );
      const statusDel = res.data[this.formBooking.photoProof[index]];

      if (statusDel) {
        this.formBooking.photoProof[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
